module.exports = __webpack_public_path__ + "static/media/IconModalAcessoEmpresa.3cfead96.svg";